import React, { useEffect, useState } from 'react';

import { useLanguage } from 'Context/LanguageContext';

import { StatusContainer } from './ActiveInactiveStatus.styles';

const colors = {
	active: {
		color: '#01B74C',
		background: '#E5FCF1',
		text: '',
	},
	inactive: {
		color: '#FF6D00',
		background: '#F8EDE1',
		text: '',
	},
};

function ActiveInactiveStatus({ isActive, textActive, textInactive }) {
	const lan = useLanguage();

	const [statusInfo, setStatusInfo] = useState(colors.inactive);

	useEffect(() => {
		if (isActive) {
			setStatusInfo({ ...colors.active, text: textActive || lan.active });
		} else {
			setStatusInfo({ ...colors.inactive, text: textInactive || lan.inactive });
		}
	}, [isActive, lan]);

	return (
		<StatusContainer color={statusInfo.color} background={statusInfo.background}>
			{statusInfo.text}
		</StatusContainer>
	);
}

export default ActiveInactiveStatus;
